import * as yup from 'yup';

export const tournamentDuplicateSchema = yup.object({
  name: yup.string().required('Nombre es requerido'),
  startDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      if (originalValue === null || originalValue === '' || originalValue === undefined) return null;
      return originalValue instanceof Date ? originalValue : new Date(originalValue);
    })
    .typeError('Fecha de inicio no es válida')
    .required('Fecha de inicio es requerida'),

  endDate: yup
  .date()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === null || originalValue === '' || originalValue === undefined) return null;
    return originalValue instanceof Date ? originalValue : new Date(originalValue);
  })
  .typeError('La fecha de fin no es válida')
  .required('La fecha de fin es requerida')
  .when('startDate', (startDate: any, schema) => {
    if (!startDate || isNaN(new Date(startDate).getTime())) {
      return schema;
    }
    return schema.min(startDate, 'La fecha de fin debe ser posterior a la fecha de inicio');
  })
});